<template>
	<CRow>
		<CCol col="12">
			<CCard>
				<CCardHeader>
					<div class="row">
						<CCol sm="6" class="align-self-center">
							<strong>{{ $lang.WithdrawalRequest.title }}</strong>
						</CCol>
						<CCol sm="6" class="align-self-center">
							<div class="text-sm-right mt-3 mt-sm-0">
								<CButtonGroup class="file-export">
									<CButton color="secondary" disabled>
										{{ $lang.buttons.export.title }}
									</CButton>
									<CButton color="danger" v-c-tooltip="$lang.buttons.export.pdf" v-on:click="exports(this, 'pdf', module, 'withdrawalRequest')">
										<i class="fas fa-file-pdf"></i>
									</CButton>
									<VueJsonToCsv class="btn btn-success" v-c-tooltip="$lang.buttons.export.excel" :json-data="json_data" :labels="json_label" :csv-title="json_title">
										<i class="fas fa-file-excel"></i>
									</VueJsonToCsv>
								</CButtonGroup>
							</div>
						</CCol>
					</div>
				</CCardHeader>
				<CCardBody>
					<CAlert :color="messageColor" closeButton :show.sync="dismissCountDownS" fade>{{ alertMessage }}
					</CAlert>
	
					<v-server-table :url="module.api.list" :columns="columns" :options="options" :data="data">
                        <template #totalPoints="data">
                            {{ data.row.currency.symbol + data.row.totalPoints }}
                        </template>
                        <template #points="data">
                            {{ data.row.currency.symbol + data.row.points }}
                        </template>
                        <template #transactionFee="data">
                            {{ data.row.currency.symbol + data.row.transactionFee }}
                        </template>
                        <template #gst="data">
                            {{ data.row.currency.symbol + data.row.gst }}
                        </template>
						<template #actions="data">
							<CButton
								color="success"
								v-c-tooltip="$lang.buttons.general.crud.view"
								v-on:click="viewTableRow(data.row)"
							>
								<i class="fas fa-eye"></i>
							</CButton>
						</template>
					</v-server-table>
				</CCardBody>
			</CCard>
		</CCol>
	</CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import { withdrawalRequest } from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import { ServerTable } from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import { minLength, required } from "vuelidate/lib/validators";
import VueJsonToCsv from "vue-json-to-csv";
import { Maxlength } from "../../store/maxlength";
import store from "@/store/store";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
	name: "CandidateItem",
	mixins: [Mixin],
	components: {
		VueJsonToCsv,
	},
	data() {
		return {
			json_data: [],
			json_label: {},
			json_title: "",
			messageColor: "success",
			alertMessage: "",
			showAlert: false,
			dismissCountDown: false,
			dismissCountDownS: false,
			self: this,
			activePage: 1,
			module: withdrawalRequest,
			maxlength: {
				name: Maxlength.candidate.title,
			},
			columns: [
				'userName', 'totalPoints', 'points', 'transactionFee', 'gst', 'status', "actions"
			],
			data: [],
			options: {
				headings: {
				'userName': 'Name',
				'totalPoints': 'Total Points',
				'points': 'Points',
				'transactionFee': 'Transaction Fee',
				'gst': 'GST',
				'status': 'Status',
				'actions': 'Actions'
				},
				sortable: ['userName'],
				filterable: ['userName']
			}
		};
	},
	validations: {
		candidate: {
			firstName: {
				required,
				minLength: minLength(1),
			},
		},
	},
	mounted() {
		let self = this;
		store.commit('showLoader', false);
		self.dismissCountDown = 0;
		self.dismissCountDownS = 0;
		if (localStorage.getItem("showAlert") !== "") {
			this.setAlert(true);
		}
		this.setAlert(false);
		localStorage.setItem("showAlert", "");
	},
	watch: {
		$route: {
			immediate: true,
			handler(route) {
				if (route.query && route.query.page) {
					this.activePage = Number(route.query.page);
				}
			},
		},
	},
	methods: {
		setAlert(value) {
			this.showAlert = value;
		},
		viewTableRow(item) {
			let self = this;
			self.$v.$reset();
			self.submitType = "Update";
			self.editId = item;
            this.$store.commit('clearSelectedRequest');
            this.$store.commit('setSelectedRequest', item);
			this.$router.push({path: `withdrawal-request/view/${item.id}`});
		},
		rowClicked(item, index) {
			this.$router.push({path: `withdrawal-request/view/${item}`});
		},
		pageChange(val) {
			this.$router.push({query: {page: val}});
		}
	},
};
</script>
